import 'Styles/templates/collection.scss';

import Overlay from '../components/overlay';
import collectionBodyApp from '../vue/collection/index';

Overlay();
collectionBodyApp();